import { useCallback, useRef } from 'react';

/**
 * Um item tocando por vez: cada vídeo/áudio da página se registra por id e,
 * ao começar a tocar, pausa todos os outros.
 */
export function useExclusivePlayback() {
  const registry = useRef(new Map<string, HTMLMediaElement>());

  const registerMedia = useCallback((id: string, element: HTMLMediaElement | null) => {
    if (element) registry.current.set(id, element);
    else registry.current.delete(id);
  }, []);

  const claimPlayback = useCallback((id: string) => {
    registry.current.forEach((element, key) => {
      if (key !== id && !element.paused) element.pause();
    });
  }, []);

  return { registerMedia, claimPlayback };
}

export function formatTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const minutes = Math.floor(seconds / 60);
  const rest = Math.floor(seconds % 60);
  return `${minutes}:${rest.toString().padStart(2, '0')}`;
}
